import { render } from "./ContractSelectionCards.vue?vue&type=template&id=a84a5ea4&scoped=true"
import script from "./ContractSelectionCards.vue?vue&type=script&lang=js"
export * from "./ContractSelectionCards.vue?vue&type=script&lang=js"

import "./ContractSelectionCards.vue?vue&type=style&index=0&id=a84a5ea4&scoped=true&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a84a5ea4"]])

export default __exports__